
<section
  class="w-full h-full max-w-1440 grid grid-cols-5"
  aria-label="Site navigation dropdown"
>
  <nav class="border-r border-l" aria-label="Navigation categories">
    <Links :activeDropdown="activeDropdown" :dropdownLinks="dropdownLinks" />
  </nav>

  <nav class="border-r" aria-label="Company links">
    <Links :activeDropdown="'company'" :dropdownLinks="dropdownLinks" />
  </nav>

  <div
    class="col-span-3 border-r"
    role="region"
    aria-label="Dropdown content area"
  >
    <DropdownFindInventory v-if="activeDropdown === 'solutions'" />
    <DropdownFeaturedGuides v-if="activeDropdown === 'guides'" />
    <DropdownResources v-if="activeDropdown === 'resources'" />
  </div>
</section>
